import "./hb-chest.module.css";
import { html } from "lit-html";
import { isPopup, isIOS } from "../../global";
//import { ifDefined } from "lit-html/directives/if-defined.js";

//const hb = new URL("../../../public/hb.svg", import.meta.url).href; // don't work...

export default (user) => html`
    <div
        id="hb-chest"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-gray-300 rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl inline-flex align-middle font-semibold text-gray-900 dark:text-white">
                        <svg
                            id="hb-chest-stamp"
                            class="hidden w-8 h-8 text-blue-800 dark:text-blue-300"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 640 640">
                            <path
                                transform="rotate(45 300 300)"
                                d="M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z" />
                        </svg>
                        <svg
                            id="hb-chest-cloud"
                            class="hidden w-8 h-8 text-blue-800 dark:text-blue-300"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 640 640">
                            <path
                                d="M32 400C32 479.5 96.5 544 176 544L480 544C550.7 544 608 486.7 608 416C608 364.4 577.5 319.9 533.5 299.7C540.2 286.6 544 271.7 544 256C544 203 501 160 448 160C430.3 160 413.8 164.8 399.6 173.1C375.5 127.3 327.4 96 272 96C192.5 96 128 160.5 128 240C128 248 128.7 255.9 129.9 263.5C73 282.7 32 336.6 32 400z" />
                        </svg>
                        <svg
                            id="hb-chest-code"
                            class="hidden w-8 h-8 text-blue-800 dark:text-blue-300"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 640 640">
                            <path
                                d="M160 224L224 224L224 160L160 160L160 224zM96 144C96 117.5 117.5 96 144 96L240 96C266.5 96 288 117.5 288 144L288 240C288 266.5 266.5 288 240 288L144 288C117.5 288 96 266.5 96 240L96 144zM160 480L224 480L224 416L160 416L160 480zM96 400C96 373.5 117.5 352 144 352L240 352C266.5 352 288 373.5 288 400L288 496C288 522.5 266.5 544 240 544L144 544C117.5 544 96 522.5 96 496L96 400zM416 160L416 224L480 224L480 160L416 160zM400 96L496 96C522.5 96 544 117.5 544 144L544 240C544 266.5 522.5 288 496 288L400 288C373.5 288 352 266.5 352 240L352 144C352 117.5 373.5 96 400 96zM384 416C366.3 416 352 401.7 352 384C352 366.3 366.3 352 384 352C401.7 352 416 366.3 416 384C416 401.7 401.7 416 384 416zM384 480C401.7 480 416 494.3 416 512C416 529.7 401.7 544 384 544C366.3 544 352 529.7 352 512C352 494.3 366.3 480 384 480zM480 512C480 494.3 494.3 480 512 480C529.7 480 544 494.3 544 512C544 529.7 529.7 544 512 544C494.3 544 480 529.7 480 512zM512 416C494.3 416 480 401.7 480 384C480 366.3 494.3 352 512 352C529.7 352 544 366.3 544 384C544 401.7 529.7 416 512 416zM480 448C480 465.7 465.7 480 448 480C430.3 480 416 465.7 416 448C416 430.3 430.3 416 448 416C465.7 416 480 430.3 480 448z" />
                        </svg>
                        <svg
                            id="hb-chest-crystal"
                            class="hidden w-8 h-8 text-blue-800 dark:text-blue-300"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 640 640">
                            <path
                                d="M180.7 97.8C185.2 91.7 192.4 88 200 88L440 88C447.6 88 454.8 91.6 459.3 97.8L571.3 249.8C578.1 259 577.4 271.7 569.8 280.2L337.8 536.2C333.3 541.2 326.8 544.1 320 544.1C313.2 544.1 306.8 541.2 302.2 536.2L70.2 280.2C62.5 271.7 61.9 259 68.7 249.8L180.7 97.8zM219.2 137.6C215.9 140.1 215 144.6 217.1 148.1L274.5 243.8L127.3 256C123.2 256.3 120 259.8 120 264C120 268.2 123.2 271.6 127.3 272L319.3 288C319.7 288 320.2 288 320.6 288L512.6 272C516.7 271.7 519.9 268.2 519.9 264C519.9 259.8 516.7 256.4 512.6 256L365.4 243.7L422.8 148.1C424.9 144.6 424 140 420.7 137.6C417.4 135.2 412.8 135.6 410 138.6L320 236.2L229.9 138.6C227.1 135.6 222.5 135.2 219.2 137.6z" />
                        </svg>
                        <span id="hb-chest-name" class="ml-2"></span>
                    </h3>
                    <button
                        id="hb-chest-close"
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-chest">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="pt-0 pb-5 my-0 space-y-0 text-base leading-[2] text-gray-900 dark:text-white">
                    <div
                        id="hb-chest-carousel"
                        class="relative w-full pt-3 pb-10 px-5"
                        data-carousel="static">
                        <!-- Carousel wrapper -->
                        <div
                            class="relative h-[74vh] overflow-hidden rounded-lg">
                            <!-- Item 1 -->
                            <div
                                id="hb-chest-carousel-1"
                                class="hidden duration-700 ease-in-out"
                                data-carousel-item="active">
                                <div
                                    class="text-gray-800 dark:text-gray-400 absolute block text-center w-full -translate-x-1/2 -translate-y-1/2 top-10 left-1/2">
                                    <div
                                        id="hb-chest-proof"
                                        class="inline-flex items-center text-base font-medium px-2.5 py-0.5 rounded-full">
                                        <span
                                            class="w-2 h-2 me-2 rounded-full"></span>
                                        <span></span>
                                    </div>
                                    <br />
                                    <span class="text-xs">
                                        Proof of Humanity by HeartBank®
                                    </span>
                                </div>
                                <hb-b></hb-b>
                                <div
                                    id="hb-chest-nearby"
                                    class="text-gray-800 dark:text-gray-400 absolute w-full text-center -translate-x-1/2 -translate-y-1/2 bottom-2 left-1/2">
                                    <svg
                                        class="w-5 h-5 inline mt-[-8px]"
                                        fill="gray"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 384 512">
                                        <path
                                            d="M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6c0 119.3-120.2 262.3-170.4 316.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z" />
                                    </svg>
                                    <span class="ml-1 text-sm"></span>
                                </div>
                                <div
                                    id="hb-chest-location"
                                    class="cursor-pointer text-gray-800 dark:text-gray-400 absolute w-full text-center -translate-x-1/2 -translate-y-1/2 bottom-[-20px] left-1/2">
                                    <span class="text-sm"></span>
                                    <span class="ml-1 text-xs"></span>
                                </div>
                            </div>
                            <!-- Item 2 -->
                            <div
                                id="hb-chest-carousel-2"
                                class="hidden duration-700 ease-in-out"
                                data-carousel-item>
                                <video
                                    id="hb-chest-cover-video"
                                    class="absolute hidden w-auto h-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                                    playsinline
                                    muted
                                    loop></video>
                                <p
                                    id="hb-chest-cover-message"
                                    class="hidden font-cursive font-bold text-center text-2xl absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 w-full h-[85%] px-4 py-5 text-black dark:text-white overflow-y-auto">
                                    Your scrollable paragraph content goes here.
                                    Add more text to test scrolling. Lorem ipsum
                                    dolor sit amet, consectetur adipiscing elit.
                                    Sed do eiusmod tempor incididunt ut labore
                                    et dolore magna aliqua. Ut enim ad minim
                                    veniam, quis nostrud exercitation ullamco
                                    laboris nisi ut aliquip ex ea commodo
                                    consequat.
                                </p>
                                <button
                                    id="hb-chest-cover-button"
                                    class="hidden absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                                    <svg
                                        class="w-20 h-20"
                                        fill="deeppink"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z" />
                                    </svg>
                                </button>
                                <p
                                    id="hb-chest-location2"
                                    class="text-xs text-gray-800 dark:text-gray-400 absolute text-center -translate-x-1/2 -translate-y-1/2 bottom-[-8px] left-1/2">
                                    ${isIOS ? "" : "Tap to play or pause"}
                                </p>
                            </div>
                            <!-- Item 3 -->
                            <div
                                id="hb-chest-carousel-3"
                                class="hidden duration-700 ease-in-out">
                                <button
                                    class="absolute block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                                    Diamond
                                </button>
                            </div>
                            <!-- Item 4 -->
                            <div
                                id="hb-chest-carousel-4"
                                class="hidden duration-700 ease-in-out"
                                data-carousel-item>
                                <section
                                    class="absolute text-center text-base block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                                    <p>
                                        Anonymous
                                        <strong>Nearby</strong> Thanking with
                                        <strong>Kiitos</strong>
                                    </p>
                                    <br /><br /><br />
                                    <p>
                                        Anonymous Nearby
                                        <strong>Tipping</strong> with Crypto
                                    </p>
                                    <!--<br /><br /><br /><br />
                                    <em>Coming Soon</em>-->
                                </section>
                                <!--<iframe
                                    id="hb-chest-youtube"
                                    loading2="lazy"
                                    class="pointer-events-none absolute block w-auto h-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                                    data-src="https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&enablejsapi=1&controls=0&modestbranding=1&rel=0&showinfo=0"
                                    title="The Zero-Point Game ℠"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allowfullscreen></iframe>-->
                            </div>
                            <!-- Item 5 -->
                            <div
                                id="hb-chest-carousel-5"
                                class="hidden duration-700 ease-in-out"
                                data-carousel-item>
                                <section
                                    id="hb-chest-ad"
                                    class="absolute block h-full w-[calc(100%-5px)] -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"></section>
                                <button
                                    class="hidden absolute text-2xl -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                                    <p class="mb-5 font-bold font-cursive">
                                        Join
                                    </p>
                                    <p class="hidden mb-5 font-cursive">at</p>
                                    <p class="font-bold">
                                        Heart
                                        <svg
                                            class="inline w-7 h-7 ml-[-7px] mt-[-3px] mr-[-3px]"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="silver"
                                            viewBox="0 0 24 24">
                                            <path
                                                stroke="silver"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                                transform="rotate(45 12 12)" />
                                        </svg>
                                        ank®
                                    </p>
                                </button>
                            </div>
                        </div>
                        <!-- Slider indicators -->
                        <div
                            class="absolute z-30 flex -translate-x-1/2 space-x-3 rtl:space-x-reverse bottom-0 left-1/2">
                            <button
                                id="hb-chest-slide-1"
                                type="button"
                                class="w-3 h-3 rounded-full bg-gray-400"
                                aria-current="true"
                                aria-label="Slide 1"
                                data-carousel-slide-to2="0"></button>
                            <button
                                id="hb-chest-slide-2"
                                type="button"
                                class="w-3 h-3 rounded-full bg-gray-400"
                                aria-current="false"
                                aria-label="Slide 2"
                                data-carousel-slide-to2="1"></button>
                            <button
                                id="hb-chest-slide-3"
                                type="button"
                                class="w-3 h-3 rounded-full bg-gray-400"
                                aria-current="false"
                                aria-label="Slide 3"
                                data-carousel-slide-to2="2"></button>
                            <button
                                id="hb-chest-slide-4"
                                type="button"
                                class="w-3 h-3 rounded-full bg-gray-400"
                                aria-current="false"
                                aria-label="Slide 4"
                                data-carousel-slide-to2="3"></button>
                            <button
                                id="hb-chest-slide-5"
                                type="button"
                                class="w-3 h-3 rounded-full bg-gray-400"
                                aria-current="false"
                                aria-label="Slide 5"
                                data-carousel-slide-to2="4"></button>
                        </div>
                        <!-- Slider controls -->
                        <button
                            id="hb-chest-carousel-previous"
                            type="button"
                            class="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                            data-carousel-prev>
                            <span
                                class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-500/30 group-hover:bg-white/50 dark:group-hover:bg-gray-500/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-500/70 group-focus:outline-none">
                                <svg
                                    class="w-4 h-4 text-white dark:text-gray-500 rtl:rotate-180"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 6 10">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M5 1 1 5l4 4" />
                                </svg>
                                <span class="sr-only">Previous</span>
                            </span>
                        </button>
                        <button
                            id="hb-chest-carousel-next"
                            type="button"
                            class="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                            data-carousel-next>
                            <span
                                class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-500/30 group-hover:bg-white/50 dark:group-hover:bg-gray-500/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-500/70 group-focus:outline-none">
                                <svg
                                    class="w-4 h-4 text-white dark:text-gray-500 rtl:rotate-180"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 6 10">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m1 9 4-4-4-4" />
                                </svg>
                                <span class="sr-only">Next</span>
                            </span>
                        </button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <a
                        href="#/onboard/start"
                        class="text-white w-full bg-yellow-700 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-base px-5 py-2.5 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
                        <strong>Get Started</strong> for FREE<br />
                    </a>
                </div>
                <p
                    class="hidden pb-3 mt-[-5px] text-xs text-center text-gray-600 dark:text-gray-400">
                    <u>No Personal Information</u> Needed
                </p>
            </div>
        </div>
    </div>
`;
